import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiService } from '../shared/rest-api.service';

//import { SearchResult } from './search-result';

@Injectable()
export class SearchService {
  constructor(private api: RestApiService) { }

  search(param: string, type: string): Observable<any> {
    return this.api.search<any>(`lu/units/${param}/${type}`);
  }
}
